export default __webpack_public_path__ + "static/media/AsthmaticaOil.4659a777.png";